import script from "./FVOCI.vue?vue&type=script&setup=true&lang=js"
export * from "./FVOCI.vue?vue&type=script&setup=true&lang=js"

import "./FVOCI.vue?vue&type=style&index=0&id=584de549&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584de549"]])

export default __exports__